import React from "react";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import Markdown from "react-markdown";
import axios from "axios";

const Article = () => {
  const [data, setData] = useState(null);

  const { slug } = useParams();

  useEffect(() => {
    console.log(slug);
    let articleContent;
    axios.get(`/articles/${slug}.md`, "utf8").then((response) => {
      setData(response.data);
      console.log(articleContent);
    });
  });

  if (!data) return <div>Loading...</div>;

  return (
    <div className="article text-left py-20">
      <Markdown>{data}</Markdown>
    </div>
  );
};

export default Article;
